import { Fire } from "@phosphor-icons/react";

const MAP = {
  eingereicht: { label: "Kontakt", cls: "bg-[#0A1128] text-white" },
  in_bearbeitung: { label: "In Bearbeitung", cls: "bg-[#334155] text-white" },
  termin: { label: "Termin", cls: "bg-[#C5A059] text-[#0A1128]", hot: true },
  kunde_geworden: { label: "Kunde geworden", cls: "bg-[#276749] text-white" },
};

export function StatusPill({ status }) {
  const s = MAP[status] || MAP.eingereicht;
  return (
    <span
      data-testid="status-pill"
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${s.cls} ${
        s.hot ? "ring-2 ring-[#C5A059]/50 shadow-[0_2px_12px_rgba(197,160,89,0.55)]" : ""
      }`}
    >
      {s.hot && <Fire size={13} weight="fill" />}
      {s.label}
    </span>
  );
}
